import React from 'react'
import ErrorPage from './ErrorPage'

// mmmm think it like a shortcut eheh
const NotFound = () => <ErrorPage error={{ response: { statusCode: 404 } }} />

export default NotFound



// WEBPACK FOOTER //
// ./src/common/NotFound.js